export interface UsuarioEmpresa {
  usuarioEmpresaId: number;
  usuarioId: number;
  nombreUsuario: string;
  empresaId: number;
  nombreEmpresa: string;
  rolId: number;
  nombreRol: string;
}

export interface CreateUsuarioEmpresaDto {
  usuarioId: number;
  empresaId: number;
  rolId: number;
}

export interface UpdateUsuarioEmpresaDto {
  usuarioId: number;
  empresaId: number;
  rolId: number;
}

class UsuarioEmpresasService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = import.meta.env.VITE_API_BASE_URL || 'https://localhost:7123/api';
  }

  private getHeaders(): Record<string, string> {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };

    const token = localStorage.getItem('authToken');
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    return headers;
  }

  private async request<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
    const url = `${this.baseUrl}${endpoint}`;

    const response = await fetch(url, {
      ...options,
      headers: this.getHeaders(),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({
        message: 'Error en la conexión con el servidor',
      }));
      throw new Error(errorData.message || `Error HTTP: ${response.status}`);
    }

    if (response.status === 204) {
      return {} as T;
    }

    return response.json();
  }

  async getAll(): Promise<UsuarioEmpresa[]> {
    return this.request<UsuarioEmpresa[]>('/usuarioempresas');
  }

  async getById(id: number): Promise<UsuarioEmpresa> {
    return this.request<UsuarioEmpresa>(`/usuarioempresas/${id}`);
  }

  async create(data: CreateUsuarioEmpresaDto): Promise<UsuarioEmpresa> {
    return this.request<UsuarioEmpresa>('/usuarioempresas', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async update(id: number, data: UpdateUsuarioEmpresaDto): Promise<UsuarioEmpresa> {
    return this.request<UsuarioEmpresa>(`/usuarioempresas/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

  async delete(id: number): Promise<void> {
    await this.request<void>(`/usuarioempresas/${id}`, {
      method: 'DELETE',
    });
  }
}

export const usuarioEmpresasService = new UsuarioEmpresasService();
